import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface SellerCellRendererComponentParams {
  sellerName: string;
  manufacturerName: string;
}

@Component({
    template: `
    <div
      class="mb-1 text-truncate custom-line-height-cell"
      data-test-selector="seller-name"
    >
      {{ sellerName }}
    </div>
    @if(manufacturerName) {
    <div
      class="text-muted fw-normal text-truncate custom-line-height-cell"
      data-test-selector="manufacturer-name"
    >
      {{ manufacturerName }}
    </div>
    }
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SellerCellRendererComponent implements ICellRendererAngularComp {
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  sellerName!: unknown;
  manufacturerName!: unknown;

  agInit({ manufacturerName, sellerName }: CustomParams): void {
    this.sellerName = sellerName;
    this.manufacturerName = manufacturerName;
    this.changeDetectorRef.detectChanges();
  }

  refresh(): boolean {
    return false;
  }
}

interface CustomParams
  extends ICellRendererParams<unknown, unknown>,
    SellerCellRendererComponentParams {}
